import { render, staticRenderFns } from "./InputForms.vue?vue&type=template&id=2bc150ee"
import script from "./InputForms.vue?vue&type=script&lang=js"
export * from "./InputForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports